module.exports = {
	container: {
		center: true,
		padding: "15px",
	},
	extend: {
		screens: {
			sm: "640px",
			md: "768px",
			lg: "1024px",
			xl: "1330px",
			"2xl": "1330px",
			"lg-down": {
				max: "1329px",
			},
			"md-down": {
				max: "1023px",
			},
			"sm-down": {
				max: "767px",
			},
			"sm-only": {
				max: "669px",
			},
		},
		colors: {
			transparent: "transparent",
			current: "currentColor",
			"body-background": "#ffffff",
			black: "#000000",
			white: "#ffffff",
			primary: {
				DEFAULT: "#18223C",
			},
			secondary: {
				DEFAULT: "#41A9E2",
			},
			accent: {
				DEFAULT: "#37D32F",
			},
		},
		margin: {
			container: "15px",
		},
		borderRadius: {
			button: "23px",
		},
		boxShadow: {
			card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
			callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
		},
	},
};
